import { render } from "./CustomerWaitlistDetailsView.vue?vue&type=template&id=c87801ea&scoped=true&ts=true&lang=pug"
import script from "./CustomerWaitlistDetailsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerWaitlistDetailsView.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerWaitlistDetailsView.vue?vue&type=style&index=0&id=c87801ea&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c87801ea"]])

export default __exports__